$(window).on('load', function () {
    var maxHeight = -1;
    var verticalSlides = $('[data-slick-announcements] > div');

    $.each(verticalSlides, function () {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    });

    $.each(verticalSlides, function () {
        if ($(this).height() < maxHeight) {
            $(this).find('.aligner').css('height', maxHeight + 'px');
        }
    });

    $('[data-slick-announcements]').slick({
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "arrows": false,
        "dots": true,
        "adaptiveHeight": false,
        "autoplay": true,
        "autoplaySpeed": 2000,
        "pauseOnHover": true,
        "pauseOnDotsHover": true,
        "vertical": true,
        "verticalSwiping": true,
        "infinite": false,
    });
});
